<header
  class="md:hidden fixed top-0 left-0 w-full bg-[#1e293b] dark:bg-[hsl(215,25%,8%)] p-4 pl-6 z-50 border-b border-gray-800 dark:border-[hsl(215,20%,22%)]"
>
  <div class="flex items-center justify-between">
  <a routerLink="/dashboard" class="flex flex-col">
    <div class="text-2xl font-semibold text-white">
      <span>Time<span class="text-blue-400">2</span>Log</span>
    </div>
    <span class="text-xs text-gray-500">Admin</span>
  </a>

    @if (showNav()) {
      <div class="relative">
        @if (isSettingsMenuOpen()) {
          <div class="fixed inset-0 z-40" (click)="toggleSettingsMenu()" tabindex="0" role="button" aria-label="Close menu"></div>
        }

        <button (click)="toggleSettingsMenu()" class="relative z-50 p-2 text-gray-400 hover:text-white rounded-lg hover:bg-[#2d3a4f] transition-colors">
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </button>

        @if (isSettingsMenuOpen()) {
          <div class="absolute top-full right-0 mt-2 w-52 bg-[#1e293b] border border-gray-700 rounded-xl shadow-2xl z-50 overflow-hidden">

            <!-- Sprache -->
            <div class="border-b border-gray-700/50">
              @for (lang of languages; track lang.code) {
                <button
                  (click)="switchLanguage(lang.code); toggleSettingsMenu()"
                  class="w-full flex items-center gap-3 px-4 py-3 text-sm text-left transition-colors hover:bg-[#2d3a4f]"
                  [class.text-white]="languageService.currentLang === lang.code"
                  [class.text-gray-400]="languageService.currentLang !== lang.code"
                >
                  <span>{{ lang.code === 'de' ? '🇩🇪' : '🇬🇧' }}</span>
                  <span>{{ lang.label }}</span>
                </button>
              }
            </div>

            <!-- Einstellungen -->
            <a routerLink="/settings" (click)="toggleSettingsMenu()" class="flex items-center gap-3 px-4 py-3 text-sm text-gray-400 hover:bg-[#2d3a4f] hover:text-white transition-colors">
              <svg class="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="3"/>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
              </svg>
              <span>{{ 'settings.title' | translate }}</span>
            </a>

            <!-- Abmelden -->
            <button (click)="logout(); toggleSettingsMenu()" class="w-full flex items-center gap-3 px-4 py-3 text-sm text-gray-400 hover:bg-[#2d3a4f] hover:text-red-400 transition-colors">
              <svg class="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                <polyline points="16 17 21 12 16 7"/>
                <line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
              <span>{{ 'auth.logout' | translate }}</span>
            </button>

          </div>
        }
      </div>
    }
  </div>
</header>

<aside
  class="fixed bottom-0 left-0 w-full bg-white dark:bg-[hsl(215,25%,8%)] text-gray-800 dark:text-[hsl(210,15%,70%)] border-t border-gray-200 dark:border-[hsl(215,20%,22%)] flex flex-col z-50 md:sticky md:top-0 md:w-64 md:h-screen md:overflow-y-auto md:shrink-0 md:bg-[#1e293b] md:text-gray-300 md:border-t-0 md:border-r md:border-gray-800"
>
  <div class="hidden md:block p-6">
    <a routerLink="/dashboard" class="block flex flex-col">
      <div class="text-2xl font-semibold text-white">
        <span>Time<span class="text-blue-400">2</span>Log</span>
      </div>
      <span class="text-xs text-gray-500">Admin</span>
    </a>

    <hr class="border-gray-700/50 mt-4" />
  </div>

<nav
  class="flex flex-row md:flex-col flex-1 justify-around md:justify-start items-center md:items-stretch md:px-4 md:space-y-2"
>
  @if (showNav()) {

    <!-- ==================== DASHBOARD ==================== -->
    <a
      routerLink="/dashboard"
      #dashboardLink="routerLinkActive"
      routerLinkActive="md:bg-[#2d3a4f] md:!text-blue-400 shadow-sm"
      [class.dark:md:bg-[#1f252e]]="dashboardLink.isActive"
      class="flex items-center justify-center md:justify-start py-1 md:py-3 md:px-4 md:rounded-lg font-medium transition-all w-full group text-[#8E9AAF] hover:md:bg-[#2d3a4f]/50 hover:md:text-gray-200"
    >
      <!-- Mobile Icon + Text -->
      <span class="md:hidden" [class.svg-active]="dashboardLink.isActive">
        <svg width="90" height="60" viewBox="0 0 120 80" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round">
            <rect x="50" y="14" width="7" height="10" rx="1.5" />
            <rect x="61" y="14" width="9" height="6" rx="1.5" />
            <rect x="50" y="27" width="9" height="7" rx="1.5" />
            <rect x="62" y="23" width="8" height="11" rx="1.5" />
          </g>
          <text x="60" y="58" font-family="Arial, sans-serif" font-size="16" fill="currentColor" text-anchor="middle">
            {{ 'nav.dashboard' | translate }}
          </text>
        </svg>
      </span>

      <!-- Desktop Icon + Text -->
      <span class="hidden md:flex items-center" [class.svg-active]="dashboardLink.isActive">
        <svg class="w-[18px] h-[18px] mr-3 shrink-0"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.75"
             stroke-linecap="round"
             stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7" rx="1"/>
          <rect x="14" y="3" width="7" height="7" rx="1"/>
          <rect x="3" y="14" width="7" height="7" rx="1"/>
          <rect x="14" y="14" width="7" height="7" rx="1"/>
        </svg>
        <span class="text-sm leading-tight">{{ 'nav.dashboard' | translate }}</span>
      </span>
    </a>

    <!-- ==================== ORGANIZATIONS ==================== -->
    <a
      routerLink="/organizations"
      #organizationLink="routerLinkActive"
      routerLinkActive="md:bg-[#2d3a4f] md:!text-blue-400 shadow-sm"
      [class.dark:md:bg-[#1f252e]]="organizationLink.isActive"
      class="flex items-center justify-center md:justify-start py-1 md:py-3 md:px-4 md:rounded-lg font-medium transition-all w-full group text-[#8E9AAF] hover:md:bg-[#2d3a4f]/50 hover:md:text-gray-200"
    >
      <!-- Mobile Icon + Text -->
      <span class="md:hidden" [class.svg-active]="organizationLink.isActive">
        <svg width="90" height="60" viewBox="0 0 120 80" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <mask id="teams-cutout">
              <rect width="100%" height="100%" fill="white" />
              <circle cx="53" cy="21" r="5.5" fill="black" />
              <path d="M45 37V35C45 31 48 28 52 28H54C58 28 61 31 61 35V37" stroke="black" stroke-width="6" fill="black"/>
            </mask>
          </defs>
          <g mask="url(#teams-cutout)">
            <circle cx="63" cy="20" r="4.5" stroke="currentColor" stroke-width="2.5" fill="none" />
            <path d="M58 31C58 28 61 26 64 26H65C68 26 71 28 71 31V36" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"/>
          </g>
          <circle cx="53" cy="21" r="4.5" stroke="currentColor" stroke-width="2.5" fill="none" />
          <path d="M46 38V35C46 31 49 28 53 28H55C59 28 62 31 62 35V38" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"/>
          <text x="60" y="58" font-family="Arial, sans-serif" font-size="16" fill="currentColor" text-anchor="middle">
            {{ 'nav.organizations' | translate }}
          </text>
        </svg>
      </span>

      <!-- Desktop Icon + Text -->
      <span class="hidden md:flex items-center" [class.svg-active]="organizationLink.isActive">
        <svg class="w-[18px] h-[18px] mr-3 shrink-0"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.75"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
        <span class="text-sm leading-tight">{{ 'nav.organizations' | translate }}</span>
      </span>
    </a>

    <!-- ==================== REPORTS ==================== -->
    <a
      routerLink="/reports"
      #reportsLink="routerLinkActive"
      routerLinkActive="md:bg-[#2d3a4f] md:!text-blue-400 shadow-sm"
      [class.dark:md:bg-[#1f252e]]="reportsLink.isActive"
      class="flex items-center justify-center md:justify-start py-1 md:py-3 md:px-4 md:rounded-lg font-medium transition-all w-full group text-[#8E9AAF] hover:md:bg-[#2d3a4f]/50 hover:md:text-gray-200"
    >
      <!-- Mobile Icon + Text -->
      <span class="md:hidden" [class.svg-active]="reportsLink.isActive">
        <svg width="90" height="60" viewBox="0 0 120 80" xmlns="http://www.w3.org/2000/svg">
          <g fill="currentColor">
            <rect x="48" y="15" width="4" height="3" rx="1" />
            <rect x="56" y="15" width="16" height="3" rx="1" />
            <rect x="48" y="23" width="4" height="3" rx="1" />
            <rect x="56" y="23" width="16" height="3" rx="1" />
            <rect x="48" y="31" width="4" height="3" rx="1" />
            <rect x="56" y="31" width="16" height="3" rx="1" />
          </g>
          <text x="60" y="58" font-family="Arial, sans-serif" font-size="16" fill="currentColor" text-anchor="middle">
            {{ 'nav.reports' | translate }}
          </text>
        </svg>
      </span>

      <!-- Desktop Icon + Text -->
      <span class="hidden md:flex items-center" [class.svg-active]="reportsLink.isActive">
        <svg class="w-[18px] h-[18px] mr-3 shrink-0"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.75"
             stroke-linecap="round"
             stroke-linejoin="round">
          <line x1="8" y1="6" x2="21" y2="6"/>
          <line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/>
          <circle cx="3" cy="6" r="0.5" fill="currentColor"/>
          <circle cx="3" cy="12" r="0.5" fill="currentColor"/>
          <circle cx="3" cy="18" r="0.5" fill="currentColor"/>
        </svg>
        <span class="text-sm leading-tight">{{ 'nav.reports' | translate }}</span>
      </span>
    </a>

    <!-- ==================== SYSTEM-ADMIN ==================== -->
    @if (isSystemAdmin()) {
      <a
        routerLink="/system-admin"
        #systemAdminLink="routerLinkActive"
        routerLinkActive="md:bg-[#2d3a4f] md:!text-blue-400 shadow-sm"
        [class.dark:md:bg-[#1f252e]]="systemAdminLink.isActive"
        class="flex items-center justify-center md:justify-start py-1 md:py-3 md:px-4 md:rounded-lg font-medium transition-all w-full group text-[#8E9AAF] hover:md:bg-[#2d3a4f]/50 hover:md:text-gray-200"
      >
        <!-- Mobile Icon + Text -->
        <span class="md:hidden" [class.svg-active]="systemAdminLink.isActive">
          <svg width="90" height="60" viewBox="0 0 120 80" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M60 13 L72 18 V27 C72 33 67 37 60 40 C53 37 48 33 48 27 V18 Z"/>
              <path d="M55 26 L59 30 L66 22"/>
            </g>
            <text x="60" y="58" font-family="Arial, sans-serif" font-size="14" fill="currentColor" text-anchor="middle">
              {{ 'nav.systemAdmin' | translate }}
            </text>
          </svg>
        </span>

        <!-- Desktop Icon + Text -->
        <span class="hidden md:flex items-center" [class.svg-active]="systemAdminLink.isActive">
          <svg class="w-[18px] h-[18px] mr-3 shrink-0"
               viewBox="0 0 24 24"
               fill="none"
               stroke="currentColor"
               stroke-width="1.75"
               stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M12 2 L20 5 V11 C20 16 16.5 20 12 22 C7.5 20 4 16 4 11 V5 Z"/>
            <path d="M9 12 L11 14 L15 10"/>
          </svg>
          <span class="text-sm leading-tight">{{ 'nav.systemAdmin' | translate }}</span>
        </span>
      </a>
    }

  }
</nav>

  <div class="hidden md:block p-4 border-t border-gray-800 dark:border-[hsl(215,20%,22%)] space-y-2">
    <div class="relative">
      @if (isLangMenuOpen()) {
        <div
          class="fixed inset-0 z-40"
          (click)="toggleLangMenu()"
          (keyup.escape)="toggleLangMenu()"
          tabindex="0"
          role="button"
          aria-label="Close menu">
        </div>
      }

      <button
        (click)="toggleLangMenu()"
        class="relative z-50 w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-gray-400 hover:text-white hover:bg-[#2d3a4f] dark:hover:bg-[#1f252e] hover:md:text-gray-200 rounded-lg transition-all"
      >
        <div class="flex items-center gap-3">
          <i class="bi bi-translate text-lg"></i>
          <span class="uppercase">{{ currentLang.code }}</span>
        </div>
        <svg
          class="w-4 h-4 transition-transform duration-200"
          [class.rotate-180]="isLangMenuOpen()"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      @if (isLangMenuOpen()) {
        <div
          class="absolute bottom-full left-0 mb-2 w-full bg-[#2d3a4f] dark:bg-[#1f252e] border border-gray-700 dark:border-[hsl(215,20%,22%)] rounded-lg shadow-2xl z-50 overflow-hidden"
        >
          @for (lang of languages; track lang.code) {
            <button
              (click)="switchLanguage(lang.code)"
              class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-left transition-colors"
              [class.bg-blue-600]="languageService.currentLang === lang.code"
              [class.dark:bg-blue-700]="languageService.currentLang === lang.code"
              [class.text-white]="languageService.currentLang === lang.code"
              [class.text-gray-300]="languageService.currentLang !== lang.code"
              [class.dark:text-[hsl(210,15%,70%)]]="languageService.currentLang !== lang.code"
            >
              <span>{{ lang.code === 'de' ? '🇩🇪' : '🇬🇧' }}</span>
              <span>{{ lang.label }}</span>
            </button>
          }
        </div>
      }
    </div>

    @if (showNav()) {
      <a
        routerLink="/settings"
        #settingsLink="routerLinkActive"
        routerLinkActive="bg-[#2d3a4f] !text-blue-400 shadow-sm"
        [class.dark:bg-[#1f252e]]="settingsLink.isActive"
        class="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-gray-400 rounded-lg hover:bg-[#2d3a4f]/50 hover:md:text-gray-200 transition-colors"
      >
        <svg class="w-[18px] h-[18px] shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
        <span>{{ 'settings.title' | translate }}</span>
      </a>

      <button
        (click)="logout()"
        class="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-gray-400 rounded-lg hover:bg-[#2d3a4f]/50 hover:text-red-400 transition-colors"
      >
        <svg class="w-[18px] h-[18px] shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
        <span>{{ 'auth.logout' | translate }}</span>
      </button>


    }
  </div>
</aside>
